import {makeStyles} from '@material-ui/core/styles'
import {colors} from '../../../shared/colors'

function getBackgroundColor(severity){
    if(severity === 'error'){
        return colors.magellanRed
    }
    else if(severity === 'success'){
        return colors.dhcsBlue
    }
}

function getColor(){
    return colors.magellanWhite
}

const useStyles = makeStyles({
    button: props => ({
        backgroundColor: getBackgroundColor(props.severity),
        color: getColor(),
        padding: '1rem',
        margin: '0.3rem',
        '&:hover':{
            backgroundColor: getBackgroundColor(props.severity),
        },
        '&:focus-visible': {
            outline: `3px solid ${getBackgroundColor(props.severity)}`,
            outlineOffset: '1px'
          }
    }),
    message: {
        fontWeight: 'bold',
        padding: '0.3rem',
        textTransform: 'none'
    },
})

export default useStyles